var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"market-box"},[_c('div',{staticClass:"all-box"},[_c('div',{staticClass:"box1"},[_c('BoxContent1')],1),_c('div',{staticClass:"box2"},[_vm._v("1")]),_c('div',{staticClass:"box3"},[_vm._v("1")]),_c('div',{staticClass:"box4"},[_c('BoxContent4')],1)])]),_c('VFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }